/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssignmentPriority = {
    Low: 'Low',
    Normal: 'Normal',
    High: 'High'
} as const;
export type AssignmentPriority = typeof AssignmentPriority[keyof typeof AssignmentPriority];


export function instanceOfAssignmentPriority(value: any): boolean {
    for (const key in AssignmentPriority) {
        if (Object.prototype.hasOwnProperty.call(AssignmentPriority, key)) {
            if (AssignmentPriority[key as keyof typeof AssignmentPriority] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssignmentPriorityFromJSON(json: any): AssignmentPriority {
    return AssignmentPriorityFromJSONTyped(json, false);
}

export function AssignmentPriorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignmentPriority {
    return json as AssignmentPriority;
}

export function AssignmentPriorityToJSON(value?: AssignmentPriority | null): any {
    return value as any;
}

export function AssignmentPriorityToJSONTyped(value: any, ignoreDiscriminator: boolean): AssignmentPriority {
    return value as AssignmentPriority;
}

